import { NavLink, Outlet } from "react-router-dom";

import { useControlPanelTabs } from "./control-panel.constants";
import styles from "./control-panel-screen.module.scss";

export function ControlPanelScreen() {
  const tabs = useControlPanelTabs();

  return (
    <section className={styles.container} data-testid="control-panel-screen">
      <header className={styles.header}>
        <h1 className={styles.title}>Painel de Controle</h1>

        <nav className={styles.tabs} aria-label="Abas do Painel de Controle">
          {tabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                [styles.tab, isActive ? styles.tabActive : ""].filter(Boolean).join(" ")
              }
              data-testid={tab.testId}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <div className={styles.content}>
        <Outlet />
      </div>
    </section>
  );
}
